export default __webpack_public_path__ + "book_details-word_wise.4f90c23a.png";